"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// Due to technical debt, we have to maintain alternative feature flag names for some cases
exports.featureFlagAliases = {
    enableDesktopContextualInstaller: "contextualInstall",
    enableiOSJoinLauncherPage: "enableiOSJoinLancherPage",
};
exports.defaultFeatureFlags = {
    disableContinueButtonOnMSIE: false,
    enableDesktopContextualInstaller: false,
    enableiOSJoinLauncherPage: false,
    showiOSSmartBannerOnFirstLaunch: false,
    enableFQDN: false,
    enableExperiment: false,
    enableNewUrlFormatForAdjust: true,
    hideDownloadButton: false,
    reportUserRepeatTelemetry: false,
    suppressPrompt: false,
    suppressPromptForMobileSafari: true,
    suppressAutoDownload: false,
    promptSuccess: false,
    msLaunch: false,
    directDl: false,
    enableWebJoin: true,
    badOSRedirectToWebJoin: true,
    enableAria: true,
    enableMobilePage: true,
    enableLWJ: true,
    enableUIv2: false,
    enableMobileUIv2: false,
    enableFreemiumMeetings: false,
    enableShareEmailUI: false,
    disableAdjustForTfl: true,
    disableAdjustForTfw: true,
    enableTflDesktopComingSoon: false,
    disableTfLDesktop: false,
    enableUserInfoParsing: false,
    enableAddingTenantIdInQsp: false,
    enableVariant10: false,
    enableTflClientProtocol: false,
    hideDownloadButtonOnTfl: false,
    enableAutoDownload: false,
    enableWindowsTfwUI: true,
    enableVisitorMarking: false,
    enableBroadcastAttendeeConveneJoin: false,
    enableTflContactSync: false,
};
